import { Badge, BadgeProps } from '@chakra-ui/react';
import { FC } from 'react';

interface ClassificationMethodBadgeProps extends BadgeProps {
  method?: string;
}

export const getClassificationMethodColor = (method: string): string => {
  switch (method.toLowerCase()) {
    case 'embedding':
    case 'embedding_labeled':
      return 'blue';
    case 'llm':
    case 'llm_embedding':
      return 'purple';
    case 'model':
      return 'green';
    default:
      return 'gray';
  }
};

export const ClassificationMethodBadge: FC<ClassificationMethodBadgeProps> = ({
  method,
  ...props
}) => (
  <Badge
    colorScheme={getClassificationMethodColor(method || 'unknown')}
    fontSize="xs"
    fontWeight="medium"
    {...props}
  >
    {method || 'unknown'}
  </Badge>
);
